"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserYieldListSchema = exports.UserYieldSchema = exports.YieldStatsListSchema = exports.YieldStatsSchema = exports.YieldProgressiveFeeSchema = exports.YieldFixedFeeSchema = exports.YieldTypeEnum = void 0;
const core_contracts_ifaces_1 = require("@tutellus/core-contracts-ifaces");
const zod_1 = require("zod");
var YieldTypeEnum;
(function (YieldTypeEnum) {
    YieldTypeEnum["FARMING"] = "FARMING";
    YieldTypeEnum["STAKING"] = "STAKING";
    YieldTypeEnum["MOVE"] = "MOVE";
})(YieldTypeEnum || (exports.YieldTypeEnum = YieldTypeEnum = {}));
exports.YieldFixedFeeSchema = zod_1.z.object({
    percentage: zod_1.z.number(),
});
exports.YieldProgressiveFeeSchema = zod_1.z.object({
    minPercentage: zod_1.z.number(),
    maxPercentage: zod_1.z.number(),
    feeInterval: zod_1.z.number(), // in seconds
});
exports.YieldStatsSchema = zod_1.z.object({
    id: zod_1.z.string({ required_error: 'yield id is required' }),
    apr: zod_1.z.number({ required_error: 'yield apr is required' }),
    tvl: core_contracts_ifaces_1.TokenAmountSchema,
    fee: zod_1.z
        .object({
        claim: exports.YieldFixedFeeSchema.optional().nullable(),
        withdraw: exports.YieldProgressiveFeeSchema.optional().nullable(),
    })
        .optional()
        .nullable(),
});
exports.YieldStatsListSchema = zod_1.z.object({
    items: zod_1.z.array(exports.YieldStatsSchema),
});
exports.UserYieldSchema = zod_1.z.object({
    yieldID: zod_1.z.string({ required_error: 'yield id is required' }),
    deposited: core_contracts_ifaces_1.TokenAmountSchema,
    rewards: zod_1.z
        .object({
        pending: zod_1.z.array(core_contracts_ifaces_1.TokenAmountSchema),
        claimed: zod_1.z.array(core_contracts_ifaces_1.TokenAmountSchema),
        earned: zod_1.z.array(core_contracts_ifaces_1.TokenAmountSchema),
    })
        .optional()
        .nullable(),
    fee: core_contracts_ifaces_1.TokenAmountSchema.optional().nullable(),
    lock: zod_1.z.number().optional().nullable(), // in seconds
});
exports.UserYieldListSchema = zod_1.z.object({
    items: zod_1.z.array(exports.UserYieldSchema),
});
